import { CHANGE_RULES } from '../constants'

export default (index, keyVals, saved = false) => ({
    type: CHANGE_RULES,
    changes: [
        {
            index,
            keyVals
        }
    ],
    update: true,
    saved
})
